import { Button, Modal, ModalBody } from "react-bootstrap";
import "./upload-resume.modal.scss";
import { useFilePicker } from "use-file-picker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile, faTrash } from "@fortawesome/free-solid-svg-icons";
import ResumeService from "../../../services/resume.service";
import GPTService from "../../../services/gpt.service";
import { TranslateModel } from "../../../model/translate.model";
import { useContext, useState } from "react";
import { ProvideContext } from "../../../context/provider.context";
import { FileAmountLimitValidator, FileSizeValidator, FileTypeValidator } from "use-file-picker/validators";
import config from "../../../config";
import FileLimitModal from "../../file-limit-modal";
import { FileErrorModel } from "../../../model/error-file-select.model";
import PrefillResumeModal from "../../resume-builder/prefill-resume.modal";
import { ResultImportResumeModel } from "../../../model/import-resume/result-import-resume.model";
import { InputResumeBuilderModel } from "../../../model/resume-builder/input-resume-builder.model";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import navigateConfig from "../../../navigate.config";


const UploadResumeModal = ({ open, handleClose, setKey, pathName }: any) => {
    const navigate = useNavigate();
    const { translateGlobal }: any = useContext(ProvideContext)
    const [translate, setTranslate] = useState<TranslateModel>(translateGlobal);
    const [isLimitError, setIsLimitError] = useState(false);
    const [fileError, setFileError] = useState<FileErrorModel>();
    const [parsedData, setParsedData] = useState<ResultImportResumeModel | null>(null);
    const [showPrefillModal, setShowPrefillModal] = useState(false);
    const [pendingResumeData, setPendingResumeData] = useState<{
        resume_name: string;
        template_id: string;
        resume_key: string;
        fileContent: string;
    } | null>(null);
    const [isUploading, setIsUploading] = useState(false);
    const [isParsing, setIsParsing] = useState(false);
    const [isCreatingResume, setIsCreatingResume] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const { openFilePicker, filesContent, loading, errors, clear } = useFilePicker({
        multiple: true,
        readAs: 'DataURL',
        accept: ['image/*', '.pdf'],
        limitFilesConfig: { min: 0, max: 1 },
        validators: [
            new FileAmountLimitValidator({ max: 1 }),
            new FileTypeValidator(['jpg', 'png', 'jpeg', 'pdf']),
            new FileSizeValidator({ maxFileSize: config.MAX_ATTACHMENT_SIZE * 1024 * 1024 })
        ],
        onFilesSuccessfullySelected: ({ plainFiles, filesContent }) => {

        },
        onFilesRejected: ({ errors }) => {
            console.log(errors);
            if (errors.length > 0) {
                const errorsResult = errors as FileErrorModel[];
                setIsLimitError(true);
                setFileError(errorsResult[0]);
            }
        }
    });


    const clearFile = () => {
        clear()
    }

    const DataURIToBlob = (dataURI: string) => {
        const splitDataURI = dataURI.split(',')
        const byteString = splitDataURI[0].indexOf('base64') >= 0 ? atob(splitDataURI[1]) : decodeURI(splitDataURI[1])
        const mimeString = splitDataURI[0].split(':')[1].split(';')[0]
        const ia = new Uint8Array(byteString.length)
        for (let i = 0; i < byteString.length; i++)
            ia[i] = byteString.charCodeAt(i)
        return new Blob([ia], { type: mimeString })
    }

    const uploadResume = () => {

        if (filesContent.length > 0) {
            const file = DataURIToBlob(filesContent[0]["content"]);
            setIsUploading(true);
            setLoadingMessage("กำลังอัปโหลดไฟล์...");

            if (pathName == "one_profile") {
                ResumeService.uploadResumeOneProfile(file, filesContent[0].name).then((res) => {

                    if (res.data.resume_key) {
                        setIsUploading(false);
                        setIsParsing(true);
                        setLoadingMessage("กำลังดึงข้อมูลจาก Resume...");
                        
                        // Parse resume first and show popup with results
                        GPTService.parseResumeFile(file, filesContent[0].name).then((parseResult) => {
                            setIsParsing(false);
                            setLoadingMessage("");
                            
                            if (parseResult.data) {
                                // Store parsed data and pending resume data
                                setParsedData(parseResult.data);
                                setPendingResumeData({
                                    resume_name: filesContent[0].name,
                                    template_id: "99",
                                    resume_key: res.data.resume_key,
                                    fileContent: filesContent[0].content
                                });
                                // Show prefill modal
                                setShowPrefillModal(true);
                            }
                        }).catch((err) => {
                            setIsParsing(false);
                            setLoadingMessage("");
                            console.error("Error parsing resume:", err);
                            // If parsing fails, show error or fallback to old flow
                            alert("ไม่สามารถ parse resume ได้: " + (err?.message || "Unknown error"));
                        });
                    } else {
                        setIsUploading(false);
                        setLoadingMessage("");
                    }

                }).catch((err) => {
                    setIsUploading(false);
                    setLoadingMessage("");
                    console.error("Error uploading resume:", err);
                    alert("เกิดข้อผิดพลาดในการอัปโหลดไฟล์: " + (err?.message || "Unknown error"));
                })
            } else {
                ResumeService.uploadResumeBuilder(file, filesContent[0].name).then((res) => {

                    if (res.data.resume_key) {
                        setIsUploading(false);
                        setIsParsing(true);
                        setLoadingMessage("กำลังดึงข้อมูลจาก Resume...");
                        
                        // Parse resume first and show popup with results
                        GPTService.parseResumeFile(file, filesContent[0].name).then((parseResult) => {
                            setIsParsing(false);
                            setLoadingMessage("");
                            
                            if (parseResult.data) {
                                // Store parsed data and pending resume data
                                setParsedData(parseResult.data);
                                setPendingResumeData({
                                    resume_name: filesContent[0].name,
                                    template_id: "99",
                                    resume_key: res.data.resume_key,
                                    fileContent: filesContent[0].content
                                });
                                // Show prefill modal
                                setShowPrefillModal(true);
                            }
                        }).catch((err) => {
                            setIsParsing(false);
                            setLoadingMessage("");
                            console.error("Error parsing resume:", err);
                            // If parsing fails, show error or fallback to old flow
                            alert("ไม่สามารถ parse resume ได้: " + (err?.message || "Unknown error"));
                        });
                    } else {
                        setIsUploading(false);
                        setLoadingMessage("");
                    }

                }).catch((err) => {
                    setIsUploading(false);
                    setLoadingMessage("");
                    console.error("Error uploading resume:", err);
                    alert("เกิดข้อผิดพลาดในการอัปโหลดไฟล์: " + (err?.message || "Unknown error"));
                })
            }



        }

    }

    const handlePrefillConfirm = (prefillData: Partial<InputResumeBuilderModel>) => {
        // After user confirms, navigate to choose template with prefill data
        if (pendingResumeData) {
            setShowPrefillModal(false);
            // Add type = "import" to prefillData
            const prefillDataWithType = {
                ...prefillData,
                type: "import"
            };
            // Navigate to choose template page with prefill data
            navigate(navigateConfig.resume.choose_template, {
                state: {
                    prefillData: prefillDataWithType,
                    isImportResume: true,
                    resumeInfo: {
                        resume_name: pendingResumeData.resume_name,
                        resume_key: pendingResumeData.resume_key,
                        fileContent: pendingResumeData.fileContent
                    }
                }
            });
            handleClose(); // Close upload modal
        } else {
            setShowPrefillModal(false);
        }
    }


    return (

        <>
            <Modal show={open} onHide={handleClose} className="upload-resume-modal-main">
                <Modal.Header className="upload-resume-modal-header" closeButton>
                    <div className="d-flex flex-column">
                        {translate.resume_builder.upload_your_resume}
                        <span className="upload-resume-modal-header-sub">{translate.error.file_limit} {config.MAX_ATTACHMENT_SIZE} MB</span>

                    </div>

                </Modal.Header>
                <ModalBody>
                    <div className="upload-resume-modal-control">
                        {
                            (isUploading || isParsing || isCreatingResume) ?
                                <div className="upload-resume-modal-content-control">
                                    <div className="upload-resume-modal-loading-control">
                                        <CircularProgress className="upload-resume-modal-loading" size={40} />
                                        <span className="upload-resume-modal-loading-text">{loadingMessage}</span>
                                    </div>
                                </div> :
                                filesContent.length > 0 ?
                                    <div className="upload-resume-modal-content-control">
                                        <div className="upload-resume-modal-selected-control">
                                            <FontAwesomeIcon icon={faFile} className="upload-resume-modal-selected-icon"></FontAwesomeIcon>
                                            <div className="upload-resume-modal-selected-filename">
                                                <span className="upload-resume-modal-desc">{filesContent[0].name}</span>
                                            </div>
                                            <FontAwesomeIcon icon={faTrash} onClick={clearFile}
                                                className="upload-resume-modal-selected-icon-delete"></FontAwesomeIcon>
                                        </div>

                                    </div> :
                                    <div className="upload-resume-modal-content-control">
                                        <span className="upload-resume-modal-desc">{translate.resume_builder.choose_file_title}</span>
                                        <span className="upload-resume-modal-header-sub text-center">{translate.error.file_support}</span>
                                        <Button onClick={openFilePicker} className="upload-resume-modal-button">{translate.resume_builder.choose_file}</Button>

                                    </div>
                        }


                    </div>
                    <Button className={
                        (filesContent.length > 0 && !isUploading && !isParsing && !isCreatingResume) 
                            ? "upload-resume-modal-upload-button" 
                            : "upload-resume-modal-upload-button upload-resume-modal-upload-button-disable"
                    }
                        onClick={uploadResume}
                        disabled={isUploading || isParsing || isCreatingResume || filesContent.length === 0}
                    >
                        {isUploading || isParsing || isCreatingResume ? "กำลังประมวลผล..." : "อัปโหลด"}
                    </Button>
                </ModalBody>
            </Modal>
            {
                isLimitError &&

                <FileLimitModal open={isLimitError} handleClose={() => setIsLimitError(false)} fileError={fileError}  limitSize={config.MAX_ATTACHMENT_SIZE}></FileLimitModal>
            }

            {
                showPrefillModal && parsedData &&
                <PrefillResumeModal
                    open={showPrefillModal}
                    handleClose={() => {
                        setShowPrefillModal(false);
                        // Don't close upload modal, let user try again
                    }}
                    parsedData={parsedData}
                    onPrefill={handlePrefillConfirm}
                />
            }

        </>
    )
}

export default UploadResumeModal;